import {inject, injectable} from 'inversify';

import type {FileApiModel} from '../../../../../api/media/file';
import type {Expand, MaybeExpanded} from '../../../../../api/types';

import {EnvProviderService} from '../../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../../Base/mappers/Base.expand.jrpc';

@injectable()
export class AssessmentExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base = {
      form: ['avatar_id'],
    };
    const b2b = base,
      core = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace AssessmentExpandJrpc {
  export type ExpandedFields = {
    avatar: MaybeExpanded<FileApiModel>;
  };
}
